/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactSlider from 'react-slider';
import { useT } from 'talkr';
import steps from '../../../survey/steps';
import questions from '../../../survey/questions';
import s from './index.module.scss';
import common from '../../index.module.scss';
import preloadImg from '../../../utils/scripts/preloadImg';

import fat0 from './img/0.png';
import fat1 from './img/1.png';
import fat2 from './img/2.png';
import fat3 from './img/3.png';
import fat4 from './img/4.png';
import fat5 from './img/5.png';
import fat6 from './img/6.png';
import fat7 from './img/7.png';

const FAT_ALIASES = {
	'4-11%': 0,
	'11-18%': 1,
	'18-25%': 2,
	'25-33%': 3,
	'33-40%': 4,
	'40-47%': 5,
	'47-54%': 6,
	'54+%': 7
};

FAT_ALIASES;

const FAT_DATA = {
	0: {
		value: '4-11%',
		img: fat0
	},
	1: {
		value: '11-18%',
		img: fat1
	},
	2: {
		value: '18-25%',
		img: fat2
	},
	3: {
		value: '25-33%',
		img: fat3
	},
	4: {
		value: '33-40%',
		img: fat4
	},
	5: {
		value: '40-47%',
		img: fat5
	},
	6: {
		value: '47-54%',
		img: fat6
	},
	7: {
		value: '54+%',
		img: fat7
	}
};

function Mark (props) {
	const isThisPreviosMark = props.thisMarkIndex < props.currentStepIndex;

	return (
		<div className={`${s.mark} ${isThisPreviosMark ? s.previousMark : ''}`} />
	);
}

function Track (data) {
	useEffect(() => {
		document.querySelector('.fatTrack-0').style.setProperty('--progress', data.data.style.left);
	});

	return (
		<div className="trackContent"> </div>
	);
}

function Fat (props) {
	const { T } = useT();
	const currentStep = useSelector((state) => state.steps.currentStep);
	const fatAnswer = useSelector((state) => state.questions.savedAnswers.fat);
	const [currentFat, setCurrentFat] = useState(fatAnswer.value ? FAT_ALIASES[fatAnswer.value.value] : 0);

	useEffect(() => {
		if (props.isThisCurrentStep || props.isThisPreviousStep || props.isThisNextStep) {
			if (window.fatImgsPreloaded) return;

			Object.entries(FAT_DATA).forEach((el) => {
				preloadImg(el[1].img);
			});

			window.fatImgsPreloaded = true;
		}

		steps.setStepStatus({
			stepName: 'fat',
			stepStatus: true
		});

		if (props.isThisCurrentStep) {
			questions.setAnswer({
				questionName: 'fat',
				answerName: 'value',
				answerValue: {
					value: FAT_DATA[currentFat].value
				}
			});
		}
	}, [currentStep]);

	function sliderChanged (data) {
		setCurrentFat(data);

		questions.setAnswer({
			questionName: 'fat',
			answerName: 'value',
			answerValue: {
				value: FAT_DATA[data].value
			}
		});
	}

	return (
		<div className={`${common.step} ${s.fat}`}>
			<h1 className={common.stepTitle}>{T('fat')}</h1>
			<img className={s.img} src={FAT_DATA[currentFat].img} alt="" />
			<ReactSlider
				value={currentFat}
				className={s.slider}
				onChange={sliderChanged}
				renderTrack={(data, trackState) => <div {...data}><Track trackState={trackState} data={data} /></div>}
				marks
				renderMark={(data) => (
					<div {...data}>
						<Mark currentStepIndex={currentFat} thisMarkIndex={data.key} />
					</div>
				)}
				min={0}
				max={7}
				thumbClassName={s.thumb}
				trackClassName="fatTrack"
				renderThumb={(data, state) => <div {...data}><div className={s.value}>{FAT_DATA[state.valueNow].value}</div></div>}
			/>
		</div>
	);
}

export default Fat;
